const Haber = resolve => {
    require.ensure(['../views/apps/haber/Haber'], () => {
        resolve(require('../views/apps/haber/Haber'))
    })
};
const HaberDetay = resolve => {
    require.ensure(['../views/apps/haber/HaberDetay'], () => {
        resolve(require('../views/apps/haber/HaberDetay'))
    })
};
const HaberTanimla = resolve => {
    require.ensure(['../views/apps/haber/HaberTanimla'], () => {
        resolve(require('../views/apps/haber/HaberTanimla'))
    })
};
const HaberlerListe = resolve => {
    require.ensure(['../views/apps/haber/HaberlerListe'], () => {
        resolve(require('../views/apps/haber/HaberlerListe'))
    })
};
const HaberlerDuzenle = resolve => {
    require.ensure(['../views/apps/haber/HaberlerDuzenle'], () => {
        resolve(require('../views/apps/haber/HaberlerDuzenle'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/haber/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/haber/kategori/KategoriTanimlama'))
    })
};

import Vue from 'vue'

Vue.component('HaberDetay', HaberDetay);
Vue.component('BultenTanimla', HaberTanimla);
Vue.component('BultenListesi', HaberlerListe);
Vue.component('BultenDuzenle', HaberlerDuzenle);
Vue.component('BultenKategorileri', KategoriTanimlama);
import layouts from '../layout'

export default {
    path: '/haber',
    name: 'haber',
    component: Haber,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'haberdetay',
            component: HaberDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
